import { SectionWithStickyInput } from '@quicktools/shared-components';
import { isMobile } from 'react-device-detect';
import ReviewSnippet from '@quicktools/shared-components/components/landingPages/ReviewSnippet/ReviewSnippet';

import { useStore } from '../../store';
import braze from '../../services/braze';
import analytics from '../../services/analytics';
import GenerateTextButton from '../../components/GenerateTextButton';
import GenerateTextBanner from '../../components/GenerateTextBanner/GenerateTextBanner';

import useStyles from './styles';
import IMainProps from './types';

function Main({
  heading,
  description,
  onChange,
  onStickyOffestChange,
  hasMobileDescription,
  inputPlaceholder,
}: IMainProps) {
  const setMainText = useStore((state) => state.setMainText);
  const showGenerateTextButton = useStore((state) => state.showGenerateTextButton);
  const showGenerateTextBanner = useStore((state) => state.showGenerateTextBanner);
  const mainText = useStore((state) => state.mainText);
  const generatedText = useStore((state) => state.generatedText);
  const cleanGeneratedText = useStore((state) => state.cleanGeneratedText);
  const classes = useStyles();

  const changeText = (text: string) => {
    setMainText(text);
    analytics.event('text_box_type');
    braze.event('text_box_type');
    onChange && onChange();
    generatedText && cleanGeneratedText();
  };

  return (
    <SectionWithStickyInput
      onChange={changeText}
      onInputClick={() => analytics.event('text_box_click')}
      primaryText={heading}
      placeholder={inputPlaceholder}
      secondaryText={description}
      hasMobileDescription={hasMobileDescription}
      onStickyOffsetChange={onStickyOffestChange}
      defaultValue={mainText}
      inputValue={generatedText}
      inputRightElement={
        showGenerateTextButton ? <GenerateTextButton className={classes.inspireBtn} /> : null
      }
      belowInputElement={showGenerateTextBanner ? <GenerateTextBanner /> : null}
      autoFocus={!isMobile}
      hasFilterButton={false}
      hasCloseIcon={true}
      reviews={
        <ReviewSnippet
          ratingValue={4.8}
          ratingCount={1284}
          title=""
          customClass={classes.reviewSnippet}
          ratingClass={classes.rating}
        />
      }
    />
  );
}

export default Main;
